module.exports = __webpack_public_path__ + "static/media/award-icon.d22cc2c0.svg";